import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import GBColorPropType from '../../prop-types/GBColor';
import SizePropType from '../../prop-types/Size';
import styles from './ribbon.css';
var cx = classnames.bind(styles);
var colorToClass = {
  teal: styles.teal,
  red: styles.red,
  green: styles.green,
  evergreen: styles.evergreen,
  white: styles.white,
  gold: styles.gold,
  orange: styles.orange
};
var sizeToClass = {
  xs: styles.xs,
  sm: styles.sm,
  lg: styles.lg,
  xl: styles.xl
};
export default function Ribbon(_ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      right = _ref.right,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["children", "className", "color", "right", "size"]);

  var classNames = [styles.ribbon];

  if (className) {
    classNames.push(className);
  }

  if (color && colorToClass[color]) {
    classNames.push(colorToClass[color]);
  }

  if (size && sizeToClass[size]) {
    classNames.push(sizeToClass[size]);
  }

  if (right) {
    classNames.push(styles.right);
  }

  return React.createElement("div", _extends({
    className: cx('ribbon', className, (_cx = {}, _defineProperty(_cx, color, styles[color]), _defineProperty(_cx, size, styles[size]), _defineProperty(_cx, "right", right), _cx))
  }, props), React.createElement("span", null, children));
}
Ribbon.propTypes = {
  /** Modal dialog content */
  children: PropTypes.node,

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Ribbon color */
  color: GBColorPropType,

  /** Ribbon is right aligned */
  right: PropTypes.bool,

  /** Ribbon size */
  size: SizePropType
};
Ribbon.defaultProps = {
  children: null,
  className: undefined,
  color: 'grey',
  right: false,
  size: 'md'
};